export default {
  init() {

    // Fixed Header
	$(window).on('scroll', () => {
		if ( $(window).width() > 768 ) {
			if ( $(window).scrollTop() > 0 ) {
				$('.site-header, .shop-header').addClass('scrolled');
			} else {
				$('.site-header, .shop-header').removeClass('scrolled');	
			}
		}
	});

	// Mobile Hamburger Navigation Toggle
	$(document).on('click', '.site-header__hamburger', function(){
		$('.site-header__off-canvas, .site-header__hamburger').toggleClass('active');
	});

	function update_variation(target) {

		var j = $('.variations_form').attr('data-product_variations');
		var json = JSON.parse(j);
		var variation_id = '';
		var price_html = '';
		var value = target.val();
		var id = target.attr('id');

		$.each(json, function(index, element) {
			if (element.attributes['attribute_' + id] == value) {
				variation_id = element.variation_id;
				price_html = element.price_html;
			}
		});	
	
		if (price_html.length > -1) {
			$('input[name="variation_id"]').val(variation_id);
			$('.single-product__price').html(price_html);
		}

	}

	var target = $('.variations select');
	
	target.on('change', function() {
		update_variation(target);
	});

	if ( $( '.variations_form' ).length > 0 ) {
		setTimeout(function() {
			update_variation(target);
		}, 200);
	}

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js